function unaVez(elemento, evento, accion) {
    var funcion = function (e) {
        if (accion(e) !== false) {
            elemento.removeEventListener(evento, funcion);
        }
    };
    elemento.addEventListener(evento, funcion);
}
export { unaVez };
